export default __webpack_public_path__ + "static/media/add-plus-outline-16px.5085e68b.svg";